import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddHeatingSystemModalComponent } from './add-heating-system-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [AddHeatingSystemModalComponent],
  imports: [
    CommonModule, SharedModule
  ],
  exports: [AddHeatingSystemModalComponent],
  entryComponents: [AddHeatingSystemModalComponent]
  
})
export class AddHeatingSystemModalModule { }
